module.exports = {
    "tr": {
        "Error_Page_500_Error_Label": "Bir hata oluştu.",
        "Layout_SideMenu_Homepage": "Anasayfa",
        "Layout_SideMenu_SignIn": "Giriş Yap",
        "Layout_SideMenu_Error_Page": "Bir Hata Oluştu",
        "Error_Page_404_Error_Title": "Sayfa Bulunamadı",
        "Error_Page_404_Error_Label": "Aradığınız sayfa bulunamadı.",
        "Content_Products_Sorting_Title": "Sırala",
        "Content_Products_Sorting_Price_Low_To_High": "Fiyat artan",
        "Content_Products_Sorting_Price_High_To_Low": "Fiyat azalan",
        "Content_Products_Sorting_New_To_Old": "Yeniden eskiye",
        "Content_Products_Sorting_Old_To_New": "Eskiden yeniye",
        "Content_Products_Filter_Brands_Title": "Markalar",
        "Content_Products_Filter_Tags_Title": "Etiketler",
        "Content_Products_Filter_Brands_Placeholder": "Marka ara",
        "Content_Products_Filter_Tags_Placeholder": "Etiket ara",
        "Content_Products_Products_Title": "Ürünler",
        "Content_Products_Products_Category_mug": "kupa",
        "Content_Products_Products_Category_shirt": "gömlek",
        "Content_Products_Products_Item_Add_Label": "Ekle",
        "Layout_Footer_App_Name_Label": "Market",
        "Layout_Footer_Privacy_Policy_Label": "Gizlilik Politikası",
        "Static_Label_All": "Tümü",
        "Static_Label_Prev": "Geri",
        "Static_Label_Next": "İleri",
        "Content_Products_Cart_Empty_Label": "Sepetin şuan boş.",
        "Content_Reservation_Request_Header_Turkish_Label": "Türkçe",
        "Content_Reservation_Request_Header_English_Label": "İngilizce",
        "Static_Label_Navbar_Services": "Hizmetler",
        "Static_Label_Navbar_Sector": "Sektörler",
        "Static_Label_Navbar_Blog": "Bloglar",
        "Static_Label_Navbar_About_Us": "Hakkımızda",
        "Static_Label_Navbar_Contact": "İletişim",
        "Static_Label_Demirkan": "DEMİRKAN",
        "Static_Label_Consultancy": "DANIŞMANLIK",
    },
    "en": {
        "Error_Page_500_Error_Label": "Internal Server Error.",
        "Layout_SideMenu_Homepage": "Homepage",
        "Layout_SideMenu_SignIn": "Sign in",
        "Layout_SideMenu_Error_Page": "An Eror Occured",
        "Error_Page_404_Error_Title": "Not Found",
        "Error_Page_404_Error_Label": "The page you have looking for couldn't found",
        "Content_Products_Sorting_Title": "Sorting",
        "Content_Products_Sorting_Price_Low_To_High": "Price low to high",
        "Content_Products_Sorting_Price_High_To_Low": "Price high to low",
        "Content_Products_Sorting_New_To_Old": "New to old",
        "Content_Products_Sorting_Old_To_New": "Old to new",
        "Content_Products_Filter_Brands_Title": "Brands",
        "Content_Products_Filter_Tags_Title": "Tags",
        "Content_Products_Filter_Brands_Placeholder": "Search brand",
        "Content_Products_Filter_Tags_Placeholder": "Search tag",
        "Content_Products_Products_Title": "Products",
        "Content_Products_Products_Category_mug": "mug",
        "Content_Products_Products_Category_shirt": "shirt",
        "Content_Products_Products_Item_Add_Label": "Add",
        "Layout_Footer_App_Name_Label": "Market",
        "Layout_Footer_Privacy_Policy_Label": "Privacy Policy",
        "Static_Label_All": "All",
        "Static_Label_Prev": "Prev",
        "Static_Label_Next": "Next",
        "Content_Products_Cart_Empty_Label": "Your cart is empty.",
        "Content_Reservation_Request_Header_Turkish_Label": "Turkish",
        "Content_Reservation_Request_Header_English_Label": "English",
        "Static_Label_Navbar_Services": "Services",
        "Static_Label_Navbar_Sector": "Sectors",
        "Static_Label_Navbar_Blog": "Blogs",
        "Static_Label_Navbar_About_Us": "About Us",
        "Static_Label_Navbar_Contact": "Contact",
        "Static_Label_Demirkan": "DEMIRKAN",
        "Static_Label_Consultancy": "CONSULTANCY",
    }
}